/* eslint-disable max-lines-per-function */
/**
 * @file  Detail
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useEffect, useState, useContext} from 'react';
import {Button, Input, message, Popover} from 'antd';
import moment from 'moment';
import {useHistory} from 'react-router-dom';
import Iconfont from '~/component/Iconfont';
import {BasicLayoutContext} from '~/layout/BasicLayout';
import {getInfoById, getNewsInfo} from '~/service/cms';

import './index.less';


function Detail(props) {
    const {match: {params: {id}}, location: {search}} = props;
    const history = useHistory();
    const [newsTitle, setNewsTitle] = useState('');
    const [publishTime, setPublishTime] = useState(0);
    const [newsContent, setNewsContent] = useState('');
    const [title, setTitle] = useState('');
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [timeZone, setTimeZone] = useState('');
    const [content, setContent] = useState('');
    const [webcast, setWebcast] = useState('');
    const [earningsRelease, setEarningsRelease] = useState([]);
    const [presentation, setPresentation] = useState([]);
    const [transcript, setTranscript] = useState([]);
    const [infographicUrl, setInfographicUrl] = useState('');
    const isNews = search === '?type=news';
    const isUpcomingEvents = search === '?type=upcoming-event';
    const layoutContext = useContext(BasicLayoutContext);
    const {isMobile} = layoutContext ?? {};

    useEffect(() => {
        window.scrollTo(0, 0);
        if (isNews) {
            getNewsInfo({id})
                .then(({data}) => {
                    const {title, publishTime, newsContent} = data;
                    setNewsTitle(title);
                    setPublishTime(publishTime);
                    setNewsContent(newsContent);
                })
                .catch(() => {
                    message.info('获取新闻详情失败');
                });
        }
        else {
            getInfoById({uid: id})
                .then(({data}) => {
                    const {
                        content:
                            {
                                title,
                                date,
                                time,
                                timeZone,
                                content,
                                webcast,
                                earningsRelease,
                                presentation,
                                transcript,
                                infographic = {},
                            }
                    } = data;
                    const {url} = infographic;
                    setTitle(title);
                    setDate(date);
                    setTime(time);
                    setTimeZone(timeZone);
                    setContent(content);
                    setWebcast(webcast);
                    setEarningsRelease(earningsRelease);
                    setPresentation(presentation);
                    setTranscript(transcript);
                    setInfographicUrl(url);
                })
                .catch(() => {
                    message.error('获取内容详情失败');
                });
        }
    }, []);

    function handleCalendar() {
        const {href} = window.location;
        window.open(
            `/api/schedule/download.json?title=${title}&dtStart=${`${date} ${time} ${timeZone}`}&detailUrl=${href}`
        );
    }

    function handleBack() {
        if (isNews) {
            history.push('news/releases');
        }
        else {
            window.history.back();
        }
    }

    return (
        <div className="detail-container">
            {
                !isMobile && (
                    <div
                        className="detail-back"
                        role="button"
                        onClick={handleBack}
                        tabIndex={0}
                    >
                        <Iconfont type="iconmianbaoxiexiayiji" className="iconmianbaoxiexiayiji" />
                        <span className="detail-back-btn">Back</span>
                    </div>
                )
            }

            <div className="detail-title">
                {
                    isNews
                        ? (
                            <span>
                                {newsTitle}
                            </span>
                        )
                        : (
                            <span>
                                {title}
                            </span>
                        )
                }
            </div>
            <div className="detail-date">
                {
                    isNews
                        ? (
                            <span>
                                {moment(publishTime).format('YYYY-MM-DD')}
                            </span>
                        )
                        : (
                            <span>
                                {`${`${date} ${time}`} ${timeZone}`}
                            </span>
                        )
                }
                {
                    isUpcomingEvents && (
                        <div
                            role="button"
                            onClick={handleCalendar}
                            tabIndex={0}
                        >
                            <Popover content="Add to Calendar">
                                <Iconfont type="iconrili" className="iconrili" />
                            </Popover>
                        </div>

                    )
                }
            </div>

            {
                !isNews && (
                    <div className="detail-btns">
                        {
                            !!webcast && (
                                <a href={webcast} target="_blank">
                                    <Button
                                        icon={<Iconfont type="iconguangbo" className="detail-icon" />}
                                        className="detail-button"
                                    >
                                        Webcast
                                    </Button>
                                </a>

                            )
                        }

                        {
                            !!earningsRelease && !!earningsRelease[0] && (
                                <a href={earningsRelease[0].url} target="_blank">
                                    <Button
                                        icon={<Iconfont type="iconfujian" className="detail-icon" />}
                                        className="detail-button"
                                    >
                                        Release
                                    </Button>
                                </a>
                            )
                        }

                        {
                            !!presentation && !!presentation[0] && (
                                <a href={presentation[0].url} target="_blank">
                                    <Button
                                        icon={<Iconfont type="iconfujian" className="detail-icon" />}
                                        className="detail-button"
                                    >
                                        Presentation
                                    </Button>
                                </a>
                            )
                        }

                        {
                            !!transcript && !!transcript[0] && (
                                <a href={transcript[0].url} target="_blank">
                                    <Button
                                        className="detail-button"
                                        icon={<Iconfont type="iconfujian" className="detail-icon" />}
                                    >
                                        Transcript
                                    </Button>
                                </a>
                            )
                        }

                        {
                            infographicUrl && (
                                <Button
                                    className="detail-button"
                                    icon={<Iconfont type="iconfujian" className="detail-icon" />}
                                    // eslint-disable-next-line react/jsx-no-bind
                                    onClick={() => {
                                        window.open(infographicUrl);
                                    }}
                                >
                                    Infographic
                                </Button>
                            )
                        }
                    </div>

                )
            }
            {
                isNews
                    ? (
                        <div
                            className="detail-content"
                            dangerouslySetInnerHTML={{__html: newsContent}}
                        >
                        </div>
                    )
                    : (
                        <div
                            className="detail-content"
                            dangerouslySetInnerHTML={{__html: content}}
                        >
                        </div>
                    )
            }
        </div>
    );
}

export default Detail;
